import ListSubheader from 'components/Luxkit/List/ListSubheader'
import { deleteRecentSearch } from 'components/Search/utils'
import { useAppSelector } from 'hooks/reduxHooks'
import noop from 'lib/function/noop'
import React, { useCallback } from 'react'
import RecentSearchSuggestionItem from './RecentSearchSuggestionItem'
import styled from 'styled-components'
import Caption from 'components/Luxkit/Typography/Caption'
import { rem } from 'polished'
import cn from 'clsx'

const StyledCaption = styled(Caption)`
  padding: 0 0 ${rem(8)};
`

const RecentSearchItemContainer = styled.div`
  &.horizontal {
    display: flex;
    gap: ${rem(40)};
  }
`

interface Props {
  recentSearches: Array<App.FullRecentSearch>;
  onDelete?: (item: App.FullRecentSearch) => void;
  closeDropdown?: () => void;
  selectedDropdown?: number;
  onRecentSearchClick: (recentSearch: App.FullRecentSearch) => void;
  horizontal?: boolean;
  iconBackground?: boolean;
}

function RecentSearchSuggestions(props: Props) {
  const { recentSearches, onDelete = noop, selectedDropdown, onRecentSearchClick, horizontal, iconBackground } = props

  const memberId = useAppSelector(state => state.auth.account.memberId)
  const onDeleteClick = useCallback((recentSearch: App.FullRecentSearch) => {
    deleteRecentSearch(recentSearch.recentSearchId, memberId!)
    onDelete(recentSearch)
  }, [memberId, onDelete])

  return (
    <div data-testid="search-recent-searches">
      {!iconBackground && <ListSubheader>Recent searches</ListSubheader>}
      {iconBackground && <StyledCaption variant="large" weight="bold">Recent searches</StyledCaption>}
      <RecentSearchItemContainer className={cn({ horizontal })}>
        {recentSearches.map((recentSearch, index) => <RecentSearchSuggestionItem
          key={recentSearch.recentSearchId}
          selected={index === selectedDropdown}
          iconBackground={iconBackground}
          recentSearch={recentSearch}
          onClick={onRecentSearchClick}
          onDelete={onDeleteClick}
          horizontal={horizontal}
        />)}
      </RecentSearchItemContainer>
    </div>
  )
}

export default RecentSearchSuggestions
